import Vue from "vue";
import VueRouter from "vue-router";
import Routes from "./routes";
import store from "./../store";

//import NProgress from "nprogress";
//import "nprogress/nprogress.css";

Vue.use(VueRouter);

const Router = new VueRouter({
    mode: "history", // "hash",
    base: process.env.BASE_URL,
    routes: Routes
});

Router.beforeResolve((to, from, next) => {
    //NProgress.start();
    let isSignIn = store.getters["auth/isSignIn"];

    if (!to.meta.public && !isSignIn) {
        if (from.name !== "login") {
            next({name: "login"});
        }
    } else {
        next();
    }
});

Router.afterEach(() => {
    //NProgress.done();
});

export default Router;